import { render, staticRenderFns } from "./BannerBgOne.vue?vue&type=template&id=0d608d80&"
import script from "./BannerBgOne.vue?vue&type=script&lang=js&"
export * from "./BannerBgOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports